export const enables = [
  { label: 'Activated', value: true },
  { label: 'Deactivated', value: false },
];

export const requireds = [
  { label: 'Required', value: true },
  { label: 'Optional', value: false },
];
